import { IForm } from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'keyword',
      type: 'input',
      label: '关键词',
      placeholder: '请输入关键词',
      rules: { required: true, message: '关键词是必选的', trigger: 'blur' }
    },
    {
      field: 'teacher',
      type: 'select',
      label: '所属老师',
      placeholder: '请选择所属老师',
      options: [],
      rules: { required: true, message: '所属老师是必选的', trigger: 'blur' }
    },
    {
      field: 'classname',
      type: 'select',
      label: '所属节目',
      placeholder: '请选择所属节目',
      options: [],
      rules: { required: true, message: '所属节目是必选的', trigger: 'blur' }
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
